import {User, Business, Team} from "@irati/types"

/**
 * @deprecated: Support for old role model and old UI, do not export.
 */
enum UserRole {
  Manager = "manager",
  Admin = "admin",
  SuperAdmin = "super-admin"
}

export function isGlobalAdmin(business: Business, user: User) {
  if (user && user.isGlobalAdmin) {
    return user.isGlobalAdmin
  }
  if (user && !user.role) {
    // Probably deprecated, leaving for safety.
    return business.globalAdminIds.includes(user.uuid)
  }
  return false
}

export function isManagerOfTeam(team: Team, user: User) {
  /**
   * @todo: We will be attaching individual user:team mappings to each user object in future, future UI work will consume this.
   */
  if (team && user.role === UserRole.Manager) {
    return true
  }

  return false
}

export function isLeaderOfTeam(team: Team, user: User) {
  /**
   * @todo: We will be attaching individual user:team mappings to each user object in future, future UI work will consume this.
   */
  if (team && user.role === UserRole.Manager) {
    return true
  }

  return false
}
